export const deleteDialog = {
  watch: {
    deleteDialog(val) {
      val || this.closeDeleteDialog()
    },
  },
}
